import {VanillaVoidCallback} from "../VanillaReader/VanillaReaderModel";

export class VanillaReaderUiButtonMenu {
    private _style = `
    <style>
        #vanilla-reader__button-side-menu {
            opacity: 1;
            height: 24px;
            width: auto;            
            bottom: 8px;
            transition: opacity ease-in-out 0.2s;            
            cursor: pointer;
            z-index: 1;
            background-color: transparent;
            font-size:1.5rem;
            color: var(--vanilla-reader__color__ui__foreground-dark);
            border: none;
        }
        #vanilla-reader__button-menu {
            opacity: 1;
            height: 24px;
            width: auto;            
            bottom: 8px;
            transition: opacity ease-in-out 0.2s;            
            cursor: pointer;
            z-index: 1;
            opacity: 0.5;
            background-color: var(--vanilla-reader__color__ui__background-light);
            color: var(--vanilla-reader__color__ui__foreground-dark);
        }
    </style>`;
    private _template = `
        <button id="vanilla-reader__button-side-menu" title="Open main menu" tabindex="0" accesskey="m"><span aria-hidden="true">menu</span></button>
        <button id="vanilla-reader__button-menu" title="Open main menu" tabindex="0" accesskey="m"><span aria-hidden="true">drag_handle</span></button>
    `;
    private _onClickCallback: VanillaVoidCallback | undefined;
    private _onMenuVisibleCallback: VanillaVoidCallback | undefined;
    private _onMenuHiddenCallback: VanillaVoidCallback | undefined;
    private _menuButton: HTMLButtonElement;

    private _onSideMenuClickCallback: VanillaVoidCallback | undefined;
    private _onSideMenuVisibleCallback: VanillaVoidCallback | undefined;
    private _onSideMenuHiddenCallback: VanillaVoidCallback | undefined;
    private _sideMenuButton: HTMLButtonElement;

    constructor(private _hostElement: HTMLElement, insertPosition: InsertPosition = 'beforeend') {
        this._hostElement.insertAdjacentHTML(insertPosition, this._style);
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._sideMenuButton = this._hostElement.querySelector('#vanilla-reader__button-side-menu')!;
        this._sideMenuButton.addEventListener('click', (_ev: MouseEvent) => {
            if (this._onSideMenuClickCallback) {
                this._onSideMenuClickCallback();
            }
        });

        this._menuButton = this._hostElement.querySelector('#vanilla-reader__button-menu')!;
        this._menuButton.addEventListener('click', (_ev: MouseEvent) => {
            if (this._onClickCallback) {
                this._onClickCallback();
            }
        });
    }

    show(): void {
        this._menuButton.removeAttribute('aria-hidden');
        this._menuButton.style.opacity = '1';
        this._menuButton.style.pointerEvents = 'all';
        if (this._onMenuVisibleCallback) {
            this._onMenuVisibleCallback();
        }
    }

    hide(): void {
        this._menuButton.ariaHidden = 'true';
        this._menuButton.style.opacity = '0';
        this._menuButton.style.pointerEvents = 'none';
        if (this._onMenuHiddenCallback) {
            this._onMenuHiddenCallback();
        }
    }

    onMenuClick(callback: VanillaVoidCallback): void {
        this._onClickCallback = callback;
    }

    onMenuVisible(callback: VanillaVoidCallback): void {
        this._onMenuVisibleCallback = callback;
    }

    onMenuHidden(callback: VanillaVoidCallback): void {
        this._onMenuHiddenCallback = callback;
    }



    showSideMenu(): void {
        this._sideMenuButton.removeAttribute('aria-hidden');
        this._sideMenuButton.style.opacity = '1';
        this._sideMenuButton.style.pointerEvents = 'all';
        if (this._onSideMenuVisibleCallback) {
            this._onSideMenuVisibleCallback();
        }
    }

    hideSideMenu(): void {
        this._sideMenuButton.ariaHidden = 'true';
        this._sideMenuButton.style.opacity = '0';
        this._sideMenuButton.style.pointerEvents = 'none';
        if (this._onSideMenuHiddenCallback) {
            this._onSideMenuHiddenCallback();
        }
    }

    onSideMenuClick(callback: VanillaVoidCallback): void {
        this._onSideMenuClickCallback = callback;
    }

    onSideMenuVisible(callback: VanillaVoidCallback): void {
        this._onSideMenuVisibleCallback = callback;
    }

    onSideMenuHidden(callback: VanillaVoidCallback): void {
        this._onSideMenuHiddenCallback = callback;
    }

}
